module.exports = __webpack_public_path__ + "img/ctrl-swap-theta.93c85df3.svg";